import React, { FC, useState } from 'react';
import Image from 'components/image/Image';
import Button from 'components/Button/Index';
import { AuthService } from 'services/auth/auth';
import { IMe } from 'core/interface/me';
import { useSelector } from 'react-redux';
import { RootState, store } from '../../../redux/store';
import { SaveCompanies } from '../../../redux/slices/company';
import ImagePicker from 'components/imagePicker';

import './Index.scss';

const CompanyAvatar = ({
  t,
  onPopupClose,
  selectedCompanyEdit
}: any): JSX.Element => {
  const { dispatch } = store;
  const me = useSelector((state: IMe) => state.user).user;
  const { companies } = useSelector((state: RootState) => state.company);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleAvatarSave = async (): Promise<void> => {
    if (!selectedFile) return;

    setLoading(true);
    const formData = new FormData();
    formData.append('logo', selectedFile);

    try {
      const res = await AuthService.getAccountCompany(me.company, formData);

      if (res) {
        dispatch(SaveCompanies(res));
        onPopupClose();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="av">
      <div className="av__content">
        {companies?.logo && !selectedFile && (
          <img src={companies?.logo} alt="" className="cropper" />
        )}
        <ImagePicker setLogo={setSelectedFile} logo={selectedFile} max={1} />
        <Button
          isLoading={loading}
          onClick={handleAvatarSave}
          t={t}
          title="Save"
          className="av__content-save"
          disabled={!selectedFile}
        />
      </div>
    </div>
  );
};

export default CompanyAvatar;
